import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_H_C, LL_V_L, ModuleFE_AppConfig, ModuleFE_Dialog, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_PertinentCategory_Order } from '@app/advisor-ui-shared';
import { ICONS } from '@app/styles';
import './ConfigDialog_PertinentCategory_Order.scss';
import { MultiSelect_PertinentCategory } from '../../../_entity/pertinent-category/ui-components.js';
export class ConfigDialog_PertinentCategory_Order extends ComponentSync {
    // ######################## Static ########################
    static show() {
        const model = {
            dialogKey: ConfigKey_PertinentCategory_Order,
            closeOverlayOnClick: () => true,
            content: _jsx(ConfigDialog_PertinentCategory_Order, {}),
        };
        ModuleFE_Dialog.show(model);
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable ??= this.getEditable();
        return state;
    }
    // ######################## Logic ########################
    getEditable() {
        const config = ModuleFE_AppConfig.cache.find(config => config.key === ConfigKey_PertinentCategory_Order) ?? {
            key: ConfigKey_PertinentCategory_Order,
            data: []
        };
        const editable = new EditableDBItemV3(config, ModuleFE_AppConfig);
        editable.setAutoSave(true);
        editable.setOnChanged(async () => this.forceUpdate());
        editable.setOnSaveCompleted(() => this.forceUpdate());
        return editable;
    }
    closeDialog = () => {
        ModuleFE_Dialog.close();
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'config-dialog__pertinent-category-order', className: 'config-dialog', children: [this.render_Title(), this.render_Content()] });
    }
    render_Title = () => {
        return _jsxs(LL_H_C, { className: 'config-dialog__title', children: ["Editor - Pertinent Category Order", _jsx(ICONS.x.component, { className: 'config-dialog__title-icon', onClick: this.closeDialog })] });
    };
    render_Content = () => {
        return _jsx(LL_H_C, { className: 'config-dialog__content', children: _jsx(TS_PropRenderer.Vertical, { label: 'Categories', children: _jsx(MultiSelect_PertinentCategory.sortable, { editable: this.state.editable, prop: 'data' }) }) });
    };
}
//# sourceMappingURL=ConfigDialog_PertinentCategory_Order.js.map